module.exports = __webpack_public_path__ + "static/img/shenpin.d0289dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shenpin.jpg
// module id = Z3sA
// module chunks = 1